import {Routes} from "@angular/router";

import {COYO_PLUGIN_PROVIDERS} from "./coyo-plugin/coyo-plugin.providers";
import {Route} from "./core/Routes";
import {AppRoute} from "./shared/app.route.enum";

export const APP_ROUTES: Routes = [
  {
    path: "",
    redirectTo: `/${AppRoute.Home}`,
    pathMatch: "full",
  },
  {
    path: AppRoute.IframePlugin,
    loadChildren: () => import("./iframe-plugin/iframe-plugin.routes").then((m) => m.IFRAME_PLUGIN_ROUTES),
  },
  {
    path: AppRoute.StaffbasePlugin,
    loadChildren: () =>
      import("./staffbase-plugin/staffbase-plugin.routes").then((m) => m.STAFFBASE_PLUGIN_ROUTES),
  },
  {
    path: AppRoute.StaffbasePluginEditor,
    loadComponent: () => import("./staffbase-plugin/editor/editor.component").then((m) => m.EditorComponent),
  },
  {
    path: AppRoute.StaffbasePluginUser,
    // The Staffbase gateway loads the user view via this top-level route; it needs
    // the same plugin service providers the /staffbase-plugin branch declares.
    providers: COYO_PLUGIN_PROVIDERS,
    loadChildren: () => import("./staffbase-plugin/user/user.routes").then((m) => m.STAFFBASE_USER_ROUTES),
  },
  {
    path: AppRoute.CoyoPlugin,
    loadChildren: () => import("./coyo-plugin/coyo-plugin.routes").then((m) => m.COYO_PLUGIN_ROUTES),
  },
  {
    path: AppRoute.UnilyPlugin,
    loadChildren: () => import("./unily-plugin/unily-plugin.routes").then((m) => m.UNILY_PLUGIN_ROUTES),
  },
  Route.withBaseLayoutAndAuthentication([
    {
      path: AppRoute.Podcasts,
      loadChildren: () => import("./podcasts/podcasts.routes").then((m) => m.PODCAST_ROUTES),
    },
    {
      path: AppRoute.Episodes,
      loadChildren: () => import("./episodes/episodes.routes").then((m) => m.EPISODES_ROUTES),
    },
    {
      path: AppRoute.Discover,
      loadChildren: () => import("./discovery/discovery.routes").then((m) => m.DISCOVERY_ROUTES),
    },
    {
      path: AppRoute.Home,
      loadChildren: () => import("./home/home.routes").then((m) => m.HOME_ROUTES),
    },
    {
      path: AppRoute.Profile,
      loadChildren: () => import("./profile/profile.routes").then((m) => m.PROFILE_ROUTES),
    },
    {
      path: AppRoute.Groups,
      loadChildren: () => import("./groups/groups.routes").then((m) => m.GROUP_ROUTES),
    },
  ]),
  {
    path: AppRoute.Settings,
    loadChildren: () => import("./settings/settings.routes").then((m) => m.SETTINGS_ROUTES),
  },
];
